export enum TrackingImageSources {
  Unsplash = 'unsplash',
  Custom = 'custom',
}
